import {Button, Card, Result} from "antd";
import React, {useEffect} from "react";
import api from "../http";
import {useAuth} from "../contexts/AuthContext";
import {useLocation, useNavigate} from "react-router-dom";


const TgConnect = () => {
    const {userInfo, setUserInfo} = useAuth();
    const url = useLocation();
    const navigate = useNavigate()



    useEffect(() => {
        const registration = async () => {
            if (url.search && !userInfo.telegramId) {
                const clearTgId = url.search.replace('?chat_id=', '');
                try {
                    const createTgResponse = await api.post(`settings/create-telegramId/${clearTgId}`);
                    if (createTgResponse.status === 200) {
                        setUserInfo(prevState => ({
                            ...prevState,
                            telegramId: createTgResponse.data.telegramId
                        }))
                    }
                } catch (err) {
                    console.error(err);
                }
            }
        };

        registration();
    }, [url.search, setUserInfo, userInfo.telegramId]);


    if (!userInfo.telegramId)
        return (
            <Card
                style={{
                    borderRadius: 10,
                    margin: 20,
                    padding: 30,
                    width: "98%",
                }}
            >
                <Result
                    status="warning"
                    title="Your Telegram isn't connected yet"
                    subTitle={"To continue using the system, you need to connect the Telegram bot. It is used for notifications, confirmations, and account security"}
                    extra={
                        <Button
                            type="primary"
                            key="warning"
                            href={`${process.env.REACT_APP_TG_BOT_URL_FOR_USERS}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                        >
                            Connect Telegram
                        </Button>
                    }
                />
            </Card>

        );


    return (
        <Card
            style={{
                borderRadius: 10,
                margin: 20,
                padding: 30,
                width: "100%",
                height: 400
            }}
        >
            <Result
                status="success"
                title="Your Telegram is already connected"
                extra={
                    <Button
                        type="primary"
                        key="success"
                        onClick={(e) => navigate(`${process.env.REACT_APP_FRONTEND_URL}/dashboard/all-documents`)}
                    >
                        Return to main page
                    </Button>
                }
            />
        </Card>
    )
}

export default TgConnect;
